import { body, navbar } from "../elements";
import { wait } from "../helpers";

export function useToggle() {
  function Toggle(toggle) {
    if (!(toggle instanceof Element)) return;

    const target_id = toggle.dataset.target;
    const target = document.getElementById(target_id);

    async function open() {
      toggle.classList.add("transition");
      target.classList.add("transition");
      await wait(200);
      toggle.classList.add("open");
      toggle.classList.remove("transition");
      target.classList.add("open");
      target.classList.remove("transition");
      if (target_id === "nav") {
        navbar.classList.add("open");
        body.classList.add("nav-open");
      }
    }

    async function close() {
      toggle.classList.add("transition");
      target.classList.add("transition");
      toggle.classList.remove("open");
      target.classList.remove("open");
      if (target_id === "nav") {
        navbar.classList.remove("open");
        body.classList.remove("nav-open");
      }
      await wait(200);
      toggle.classList.remove("transition");
      target.classList.remove("transition");
    }

    toggle.addEventListener("click", () => {
      toggle.classList.contains("open") ? close() : open();
    });
  }

  const toggles = document.querySelectorAll(".toggle");

  toggles.forEach((toggle) => {
    Toggle(toggle);
  });
}
